import { render, staticRenderFns } from "./BaseValidationBottomWarning.vue?vue&type=template&id=02f24b68"
import script from "./BaseValidationBottomWarning.vue?vue&type=script&lang=js"
export * from "./BaseValidationBottomWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports